import React from 'react';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import BarChartTwoToneIcon from '@mui/icons-material/BarChartTwoTone';
import BookIcon from '@mui/icons-material/Book';
import AppsIcon from '@mui/icons-material/Apps';
import { Notifications, NotificationsOff } from '@mui/icons-material';
import PowerIcon from '@mui/icons-material/Power';
import PublishIcon from '@mui/icons-material/Publish';
import PortraitIcon from '@mui/icons-material/Portrait';
import ShareIcon from '@mui/icons-material/Share';
import PeopleIcon from '@mui/icons-material/People';
import ApprovalIcon from '@mui/icons-material/Approval';
import ContactsIcon from '@mui/icons-material/Contacts';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import ListIcon from '@mui/icons-material/List';
import { Device } from '@brightlayer-ui/icons-mui';
import { Departments } from '@brightlayer-ui/icons-mui';
import SubjectIcon from '@mui/icons-material/Subject';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { LicenseIcon } from '@brightlayer-ui/icons-mui';
import * as Colors from '@brightlayer-ui/colors';
import CategoryTwoTone from '@mui/icons-material/CategoryTwoTone';
import InsightsTwoTone from '@mui/icons-material/InsightsTwoTone';
import FolderSpecialTwoTone from '@mui/icons-material/FolderSpecialTwoTone';
import RuleTwoTone from '@mui/icons-material/RuleTwoTone';
import ManageAccountsTwoTone from '@mui/icons-material/ManageAccountsTwoTone';
import SettingsBackupRestoreTwoTone from '@mui/icons-material/SettingsBackupRestoreTwoTone';
import TuneTwoTone from '@mui/icons-material/TuneTwoTone';
import HubTwoTone from '@mui/icons-material/HubTwoTone';
import SettingsInputAntennaTwoTone from '@mui/icons-material/SettingsInputAntennaTwoTone';
import InventoryTwoTone from '@mui/icons-material/InventoryTwoTone';
import MonitorHeartTwoTone from '@mui/icons-material/MonitorHeartTwoTone';
import NotificationsActiveTwoTone from '@mui/icons-material/NotificationsActiveTwoTone';
import ElectricBoltTwoTone from '@mui/icons-material/ElectricBoltTwoTone';
import CardMembershipTwoTone from '@mui/icons-material/CardMembershipTwoTone';
import EventNoteIcon from '@mui/icons-material/EventNote';
import AnalyticsIcon from '@mui/icons-material/Analytics';

export const PRODUCTS_MENU = [
    { titleKey: 'menu.products.allproducts', link: '/products/all', dividerBefore: false, icon: <DashboardTwoToneIcon /> },
    {
        titleKey: 'menu.products.codesys', link: '/products/9050c7a7-816b-4ea3-87e6-1602c89fd255',
        name: 'CODESYS Workbench',
        icon: <img className="nav-icn" src="/plc.svg" alt="" />, id: '9050c7a7-816b-4ea3-87e6-1602c89fd255'
    },
    {
        titleKey: 'menu.products.hydroquebec', link: '/products/a86ff578-c057-4ac2-8e67-d0c47cb1c2ee',
        name: 'Hydro-Québec SMP Gateway Automation Platform',
        icon: <img className="nav-icn" src="/gateway.svg" alt="" />,id: 'a86ff578-c057-4ac2-8e67-d0c47cb1c2ee'
    },
    {
        titleKey: 'menu.products.ied', link: '/products/093a2162-f765-11e9-8f0b-362b9e1556671aa',
        name: 'IED Manager Suite',
        icon: <img className="nav-icn" src="/ims.svg" alt="" />,id: '093a2162-f765-11e9-8f0b-362b9e1556671aa'
    },
    {
        titleKey: 'menu.products.ieddemo', link: '/products/2911dd9b-06a1-4ed9-90dc-a0bba140d114',
        name: 'Demo VM - IED Manager Suite',
        icon: <img className="nav-icn" src="/ims.svg" alt="" />,id: '2911dd9b-06a1-4ed9-90dc-a0bba140d114'
    },
    {
        titleKey: 'menu.products.distributedio', link: '/products/21d49f8d-724b-4def-b49a-f3862f7fb165',
        name: 'Distributed I/O and RTU Upgrade solution',
        icon: <img className="nav-icn" src="/io.svg" alt="" />,id: '21d49f8d-724b-4def-b49a-f3862f7fb165'
    },
    {
        titleKey: 'menu.products.magnefixicap', link: '/products/9086e2ae-1a4c-4e5a-9de9-dcaed73bf5e7',
        name: 'Magnefix MD4 iCap',
        icon: <img className="nav-icn" src="/icap.svg" alt="" />,id: '9086e2ae-1a4c-4e5a-9de9-dcaed73bf5e7'
    },    
    {
        titleKey: 'menu.products.edgeplatform', link: '/products/d634ad5f-b994-4d52-ad47-85b49ec59e7c',
        name: 'Edge Platform',
        icon: <img className="nav-icn" src="/edgeplatform.svg" alt="" />,id: 'd634ad5f-b994-4d52-ad47-85b49ec59e7c'
    },    
    {
        titleKey: 'menu.products.smpgateway', link: '/products/093a2162-f765-11e9-8f0b-362b9e1556672',
        name: 'SMP Gateway Automation Platform',
        icon: <img className="nav-icn" src="/gateway.svg" alt="" />,id: '093a2162-f765-11e9-8f0b-362b9e1556672'
    },
    {
        titleKey: 'menu.products.smpconfigtool', link: '/products/36d72462-f765-11e9-8f0b-362b9e155667',
        name: "SMP Configuration Comparison Tool",
        icon: <img className="nav-icn" src="/compare2.svg" alt="" />,id: '36d72462-f765-11e9-8f0b-362b9e155667'
    },
    {
        titleKey: 'menu.products.smptools', link: '/products/618c533b-2633-40b6-87e0-849767a15106',
        name: 'SMP Tools',
        icon: <img className="nav-icn" src="/smptools.svg" alt="" />,id: '618c533b-2633-40b6-87e0-849767a15106'
    },
    {
        titleKey: 'menu.products.visualtnd', link: '/products/22a689a5-ba30-4ac4-a3d3-c83e991e4602',
        name: 'Visual T&D',
        icon: <img className="nav-icn" src="/vtd.svg" alt="" />,id: '22a689a5-ba30-4ac4-a3d3-c83e991e4602'
    },
    {
        titleKey: 'menu.products.yukonfeeder', link: '/products/fe8411cb-4ff2-4b93-a39f-139a145d1352',
        name: 'Yukon Feeder Automation',
        icon: <img className="nav-icn" src="/yfa.svg" alt="" />,id: 'fe8411cb-4ff2-4b93-a39f-139a145d1352'
    },
    {
        titleKey: 'menu.products.yukongridserver', link: '/products/5b435882-1954-5b6a-9953-07e26578ccb2',
        name: 'Yukon GridServer',
        icon: <img className="nav-icn" src="/ygs4.svg" alt="" />,id: '5b435882-1954-5b6a-9953-07e26578ccb2'
    },
    {
        titleKey: 'menu.products.smpdaplatform', link: '/products/33c57157-64fa-4063-9036-12bc4a946191',
        name: 'SMP Distribution Automation Platform',
        icon: <img className="nav-icn" src="/da.svg" alt="" />,id: '3acb1fdd-5f82-4cff-84ef-7db5ace4fa0a'
    },
    {
        titleKey: 'menu.products.feederautomationmanager', link: '/products/ff7ca44c-a623-4212-9938-05ed458bfb9a',
        name: 'Feeder Automation Manager',
        icon: <img className="nav-icn" src="/fam.svg" alt="" />,id: 'ff7ca44c-a623-4212-9938-05ed458bfb9a'
    },
    {
        titleKey: 'menu.products.yukonenterprisesoftwareplatform', link: '/products/b7eec713-8da7-4476-9a9a-a7fc12cd085e',
        name: 'Yukon Enterprise Software Platform',
        icon: <img className="nav-icn" src="/electric_meter2.svg" alt="" />,id: 'b7eec713-8da7-4476-9a9a-a7fc12cd085e'
    },
    {
        titleKey: 'menu.products.yukonnetworkmanager', link: '/products/46a1e753-7d13-43ff-a94d-c7a72052fa4f',
        name: 'Yukon Network Manager',
        icon: <img className="nav-icn" src="/yukonnetworkmanager.svg" alt="" />,id: '46a1e753-7d13-43ff-a94d-c7a72052fa4f'
    },
    {
        titleKey: 'menu.products.dtpgconfig', link: '/products/6cecb3b3-9fa8-4f4e-a289-6ef1a013cdbd',
        name: 'DTPG Configuration Tool',
        icon: <img className="nav-icn" src="/dtpg-icon.svg" alt="" />,id: '6cecb3b3-9fa8-4f4e-a289-6ef1a013cdbd'
    }
]

export const OP_ANALYTICS_MENU = [
    { titleKey: 'menu.op_analytics.analyses', link: '/analysis', icon: <BarChartTwoToneIcon /> },
    //Commenting for future reference
    // { titleKey: 'menu.op_analytics.activitylog', link: '/analysis-appevents', icon: <BookIcon /> }
]

export const LCRS_MANAGEMENT_MENU = [
    { titleKey: 'menu.lcrs_management.communications', link: '/lcrsmanagement/communications', icon: <AppsIcon /> },
    { titleKey: 'menu.lcrs_management.firmware', link: '/lcrsmanagement/firmware', icon: <BookIcon /> },
    { titleKey: 'menu.lcrs_management.market', link: '/lcrsmanagement/market', icon: <PublishIcon /> }    
]

export const dlm_menu = [
    { titleKey: 'menu.asset_management.firmware_update', link: '/dlm', icon: <PowerIcon /> },
]

export const DR_EVENTS_MENU = [
    { titleKey: 'menu.asset_management.dr_events', link: '/asset-management/dr-events', icon: <EventNoteIcon /> },
    { titleKey: 'menu.asset_management.dr_analyser', link: '/asset-management/dr-analyser', icon: <AnalyticsIcon /> },
];

export const YUKON_SYSTEMS_MENU = [
    { titleKey: 'menu.yukon_systems_menu.system_health', link: '/yukon-systems', icon: <MonitorHeartIcon /> },
    { titleKey: 'menu.yukon_systems_menu.metrics_diagrams', link: '/yukon-systems/metrics-diagrams', icon: <AccountTreeIcon /> },
    { titleKey: 'menu.yukon_systems_menu.metrics_explorer', link: '/yukon-systems/metrics', icon: <ShowChartIcon /> },
]

export const NOTIFICATIONS_MENU = [
    { titleKey: 'menu.notifications_menu.activity_log', link: '/yukon-systems/notifications', icon: <Notifications /> },
    { titleKey: 'menu.notifications_menu.alarm_silencing', link: '/yukon-systems/notifications/alarm-silencing', icon: <NotificationsOff /> },
]


export const SMP_FILES_ANALYTICS_MENU = [
    { titleKey: 'menu.smp_files_analytics.allfiles', link: '/analytics/reports', icon: <AppsIcon /> },
    { titleKey: 'menu.smp_files_analytics.myfiles', link: '/analytics/reports/my-files', icon: <BookIcon /> },
    { titleKey: 'menu.smp_files_analytics.uploadfiles', link: '/analytics/uploadfiles', icon: <PublishIcon /> }
]

export const RULES_MENU = [
    { titleKey: 'menu.rules.allrules', link: '/analytics/rules', icon: <AppsIcon /> },
    { titleKey: 'menu.rules.myrules', link: '/analytics/rules/myrules', icon: <PortraitIcon /> },
    { titleKey: 'menu.rules.sharedwithme', link: '/analytics/rules/shareWithMe', icon: <ShareIcon /> }
]

export const PRODUCT_OWNER_MENU = [
    { titleKey: 'menu.product_owner.customers', link: '/productowner/customers', icon: <PeopleIcon /> },
    { titleKey: 'menu.product_owner.autoapproval', link: '/productowner/product_autoapproval', icon: <ApprovalIcon /> },
    { titleKey: 'menu.product_owner.users', link: '/productowner/productsusers', icon: <ContactsIcon /> },
    //Commenting for future reference
    // { titleKey: 'menu.product_owner.activitylog', link: '/productowner/appevents', icon: <BookIcon /> },
    { titleKey: 'menu.product_owner.pendingapprovals', link: '/productowner/pending-approval', icon: <AccessibilityIcon /> },
    { titleKey: 'menu.product_owner.licensemanagement', link: '/productowner/license-management', icon: <LicenseIcon /> }
]

export const FACTORY_RESET_MENU = [
    { titleKey: 'menu.factory_reset.register_customer', link: '/factoryreset/register-customer', icon: <PersonAddIcon /> },
    { titleKey: 'menu.factory_reset.register_customer_site', link: '/factoryreset/register-customer-site', icon: <Departments /> },
    { titleKey: 'menu.factory_reset.find_device_by_reg_key', link: '/factoryreset/find-device-key-by-registration', icon: <FindInPageIcon /> },
    { titleKey: 'menu.factory_reset.find_device_by_type_serial', link: '/factoryreset/find-device-by-type-and-number', icon: <FindInPageIcon /> },
    { titleKey: 'menu.factory_reset.list_devices', link: '/factoryreset/list-devices', icon: <ListIcon /> },
    { titleKey: 'menu.factory_reset.device_registration', link: '/factoryreset/device-registration', icon: <Device /> },
    //Commenting for future reference
    // { titleKey: 'menu.product_owner.activitylog', link: '/factoryreset/fadr-appevents', icon: <BookIcon /> }
]
export const EDGE_PLATFORM_NAVIGATION_MENU = [
    { titleKey: "translation:menu.edge_platform.edgemanager", link: "/edgemanager", icon: <SubjectIcon /> }
];

// Renders a MUI TwoTone icon with two @brightlayer-ui/colors palette colors:
//  - the opaque outline layer  -> primary
//  - the semi-transparent fill -> secondary (kept subtle)
const twoTone = (IconCmp, primary, secondary) => (
    <IconCmp
        sx={{
            color: primary,
            '& path:nth-of-type(1)': { fill: secondary, opacity: 0.9 },
        }}
    />
);

// Icon + color metadata for the root/group menu items, keyed by the id used in drawer.jsx.
// All colors are referenced from @brightlayer-ui/colors — no hardcoded hex.
export const ROOT_MENU_META = {
    '1':  { icon: twoTone(CategoryTwoTone,               Colors.blue[500],      Colors.gold[300]) },      // Products
    '2':  { icon: twoTone(InsightsTwoTone,                Colors.lightBlue[700], Colors.lightBlue[300]) }, // Operational Analytics
    '3':  { icon: twoTone(FolderSpecialTwoTone,           Colors.orange[500],    Colors.gold[300]) },      // SMP Files Analytics
    '4':  { icon: twoTone(RuleTwoTone,                    Colors.purple[500],    Colors.purple[300]) },    // Rules
    '5':  { icon: twoTone(ManageAccountsTwoTone,          Colors.green[700],     Colors.green[300]) },     // Product Owner
    '6':  { icon: twoTone(SettingsBackupRestoreTwoTone,   Colors.red[900],       Colors.gold[900]) },    // Factory Reset
    '7':  { icon: twoTone(TuneTwoTone,                    Colors.gray[500],      Colors.blue[800]) },      // DTPG
    '8':  { icon: twoTone(HubTwoTone,                     Colors.lightBlue[500], Colors.blue[300]) },      // Edge Platform
    '9':  { icon: twoTone(SettingsInputAntennaTwoTone,    Colors.green[900],     Colors.green[900]) },     // LCRs Management
    '10': { icon: twoTone(InventoryTwoTone,               Colors.gold[500],      Colors.green[300]) },     // Asset Management
    '11': { icon: twoTone(MonitorHeartTwoTone,            Colors.lightBlue[700], Colors.red[300]) },       // Yukon Systems
    '12': { icon: twoTone(NotificationsActiveTwoTone,     Colors.orange[500],    Colors.gold[300]) },      // Notifications
    '13': { icon: twoTone(ElectricBoltTwoTone,            Colors.gold[700],      Colors.orange[800]) },    // NOVA LinePro
    '14': { icon: twoTone(CardMembershipTwoTone,          Colors.blue[500],      Colors.gold[300]) },      // License Management
};